import React from "react";
import TopHeader from "../../components/TopHeader";
import NavigationBarStudentLanding from "../../components/NavigationBarStudentLanding";
import CourseBundleDetails from "../../components/student-dashboard/course-bundle";

function CourseBundleDetailsPage() {

  return (
    <>
      <TopHeader />
      <NavigationBarStudentLanding />
      <div className="w-100">
        <CourseBundleDetails />
      </div>
    </>
  );
}

export default CourseBundleDetailsPage;
